<template>
    <div class="site__centered">
        <div class="my-applications">
          <div class="my-applications__header">
            <h2 class="my-applications__title capitalize">{{ camperStudent('plural') }} Applications</h2>
          </div>
            <div class="my-applications__row">
                <SideNav/>

                <div class="my-applications__row__col-9 my-applications__row__col-sm-12">
                    <div class="my-applications__tab-column">

                      <div class="children-list">
                        <ChildCard
                          v-for="child in childApplicationsList"
                          :key="child.id"
                          :child="child"
                          @editChild="showEditChildModal"
                        />
                      </div>

                      <div
                        class="mt-4"
                      >
                        <span v-if="!childApplicationsList.length">There are no active application on your account</span>
                        <button
                          v-b-modal.add-family-member
                          class="btn btn--color-dark family__add-member"
                          @click="$router.push('programs')"
                        >
                          Register Now
                        </button>
                      </div>

                    </div>

                  <EditChildModal
                    :is-show-modal="isShowEditChildModal"
                    :user="editableUser"
                    @closeModal="closeModal"
                    @updateChildrenList="setChildrenList"
                  />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SideNav from '@/components/site/SideNav.vue'

import { prepareApplicationSubmissionMessage } from '@core/mixins/prepareApplicationSubmissionMessage'
import store from '@/store'
import ChildCard from '@/views/My/ChildApplications/ChildCard.vue'
import EditChildModal from '@/components/site/add-new-child-modal/EditChildModal.vue'
import { instanceSessionCamperNames } from '@core/mixins/instanceSessionCamperNames'

export default {
  components: {
    EditChildModal,
    ChildCard,
    SideNav,
  },
  mixins: [prepareApplicationSubmissionMessage, instanceSessionCamperNames],
  data: () => ({
    isLoading: false,
    showThankYou: false,
    applicationProgramName: '',
    isShowEditChildModal: false,
    editableUser: {},
  }),
  async created() {
   await this.setChildrenList()
  },
  computed: {
    childApplicationsList () {
      return store.getters['applications/getChildApplicationsList']
    },
  },
  methods: {
    showEditChildModal(child) {
      this.isShowEditChildModal = true
      this.editableUser = child
    },
    closeModal() {
      this.isShowEditChildModal = false
      this.editableUser = {}
    },
    async setChildrenList() {
      store.commit('SET_LOADING_STATUS', true)

      try {
        await store.dispatch('applications/fetchChildApplicationsList')
      } catch (error) {
        console.error('Error fetching child applications:', error)
      } finally {
        store.commit('SET_LOADING_STATUS', false)
      }
    },
    async getApplicationName(id) {
      this.isLoading = true
      await store.dispatch('applications/fetchApplicationById', id)
        .then(response => {
          this.applicationProgramName = response.program
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if(from.name === "application-create"){
        if (to.query.id) {
          vm.getApplicationName(to.query.id)
          vm.showThankYou = true
        }
      }
    })
  }
}
</script>

<style scoped>
@media screen and (max-width: 767px) {
  .message__success {
    font-size: 16px;
    line-height: 20px;
    padding: 20px;
    white-space: pre-wrap;
  }
}
</style>
